import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'treatments',
    viewPath: props.viewPath,
  })

  return function onClick() {
    return submit({ type: 'create' })
  }
}
